<template>
 <div class="">
    <h3 class="text-center">MANTRA</h3>
    <div v-if="slide == 1 || mantraPrint == true" class="table border p-2">
        <pre>{{mantra.primeiro}}</pre>
    </div>
    <div v-if="slide == 2 || mantraPrint == true" class="table border p-2">
        <pre>{{mantra.segundo}}</pre>
    </div>
    <div v-if="slide == 3 || mantraPrint == true" class="table border p-2">
        <pre>{{mantra.terceiro}}</pre>
    </div>
    <div v-if="slide == 4 || mantraPrint == true" class="table border p-2">
        <pre>{{mantra.quarto}}</pre>
    </div>
     <div class="col-12 text-center mb-3 d-print-none">
        <a class="prev-link" @click.prevent="changeSlide(slide-1);" v-if="slide > 1"><i class="fa fa-chevron-left"></i></a>
        <span id="Page" class="pl-2 pr-2"> <input type="number" @change="changeSlide();" style="width:50px;" v-model="slide"> de 4</span>
        <a
        class="next-link"
        @click.prevent="changeSlide(slide+1);"
        v-if="slide < 4"
        ><i class="fa fa-chevron-right"></i></a>
        <a class="ml-3 prev-link" style="color:white;" v-if="!mantraPrint" @click.prevent="mantraPrint=true;">Ver Todas</a>
        <a class="ml-3 prev-link" style="color:white;" v-if="mantraPrint" @click.prevent="mantraPrint=false;">Esconder</a>
    </div>
 </div>
</template>

<script>
export default {
    name:"Mantra",
    props: ["mantra"],
    data(){
        return {
            tipo: "",
            slide: 1,
            sliding: null,
            mantraPrint: false,
        }
    },
    mounted(){
    },
    methods:{
        changeSlide(value){
            if(value > 1 || value < 5 ){
                this.slide = value;
            }else if(this.slide < 1 || this.slide > 4){
                this.slide = 1;
            }
        },
        
    }
}
</script>

<style scoped>
    p{
        font-size: 13px;
        padding: 0px;
        margin: 0px;
    }
    p span,.documento {
        font-size: 11px;
    }
    h3{
        margin-top: 0px;
        padding-top: 5px;
        font-size: 20px;
    }
    hr{
        margin: 5px;
    }
    
</style>